import { MenuItem } from '@mui/material';
import { MenuItemProps } from '@mui/material/MenuItem/MenuItem';

import styles from './styles.module.scss';

export const MenuItemMultipleSelect = (props: MenuItemProps) => {
  return (
    <MenuItem
      {...props}
      classes={{
        root: styles.root,
      }}
    />
  );
};
